

export default function getProducts(room, austattung_produkt){
    const productList = [];
    let combinations = {
        name: room.name,
        combinations: [],
    };
    if (room.selectedEquipment["sound"] !== undefined
        || Boolean(room.selectedEquipment["sound"])
    ) {
        if (room.selectedEquipment["sound"] > 0) {
            productList.push({
                product: austattung_produkt["sound"],
                count: room.selectedEquipment["sound"]
            });
            productList.push({
                product: austattung_produkt["sound-r"],
                count: room.selectedEquipment["sound"]
            });
            for ( let k = 0; k < room.selectedEquipment['sound']; k++) {
                let position = 1;
                let comb = {
                    frame: austattung_produkt["sound-r"],
                    factor: 1,
                    orientation: 'H',
                    controlElements: [],
                    origin: 'addAudio, 28'
                };
                comb.controlElements.push({
                    position: position,
                    insert: austattung_produkt["sound"]
                });
                combinations.combinations.push(comb);
            }
        }
    }

    return { productList: productList, combinations: combinations };
}
